<template>
  <page-template>
    <form-template>
      <template #title>{{ $t("BusyPage_title") }}</template>
      <p>
        {{ $t("BusyPage_description1") }}<br />
        {{ $t("BusyPage_description2") }}
      </p>
      <div class="mt-5">
        <button-primary classes="w-100" @click="reload" :name="$t('Reload')" />
      </div>
    </form-template>
  </page-template>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTemplate from "@/components/Authentication/PageTemplate.vue";
import FormTemplate from "@/components/Authentication/FormTemplate.vue";
import ButtonPrimary from "@/components/Button/ButtonPrimary.vue";

export default defineComponent({
  name: "BusyPage",
  components: {
    PageTemplate,
    FormTemplate,
    ButtonPrimary,
  },

  setup() {
    const reload = () => {
      location.reload();
    };

    return {
      reload,
    };
  },
});
</script>
